<template>
    <div class="d-flex flex-1 h-100 overflow-auto">
        <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none rounded-t-lg" content-class="h-auto">
                <div class="d-flex align-center">
                    <div class="custom-icon-wrapper">
                        <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                    </div>
                    <v-toolbar-title class="size-16 dark-text padding-left-xl">{{ $t("res_Label_MoveCorrespondences")
                        }}</v-toolbar-title>
                </div>
            </v-toolbar>

            <template name="Content-of-MoveCorrespondencesVue">
                <div class="border-top p-4">
                    <div id="fromEntityItemAndSearchBtn" class="d-flex">
                        <div class="col-3 p-0 margin-right-l">
                            <label class="mb-2">{{ $t("res_Label_SelectStructureOrUser") }}</label>
                            <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                                :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="false"
                                :isMultiple="false" :selectedStructureUser="fromStructureUser"
                                @structureUserSelectChanged="fromEntitySelectedChange"
                                :class="{ 'border-red-validation': validation.fromStructureUser, '': true }"
                                :addressBook_header="$t('res_Label_SelectStructureOrUser')"
                                :hideStructureWithDisableTransfer="false" :showRemoveSingleSelectBtn="true"
                                :hideUserWithDisableTransfer="false">
                            </StructureUserSelector>
                        </div>
                        <div class="col-3 p-0 margin-right-l">
                            <label class="mb-2">{{ $t("res_Label_Subject") }}</label>
                            <v-text-field v-model="filterObject.subject" label="" solo></v-text-field>
                        </div>
                        <div class="col-3 p-0 margin-right-l">
                            <label class="mb-2">{{ $t("res_MenuItems_ReferenceNumber") }}</label>
                            <v-text-field v-model="filterObject.referenceNumber" label="" solo></v-text-field>

                        </div>
                        <div class="p-0" style="width: 24%">
                            <label class="mb-1">{{ $t("res_Label_Status") }}</label>
                            <div class="with-absolute-button">
                                <multiselect class="light-bg add-arrow" v-model="filterObject.status"
                                    :label="utils.GetTranslatedValue('name', 'nameAr')" track-by="id"
                                    open-direction="bottom" :options="allStatus" :searchable="true" :loading="false"
                                    :internal-search="false" :clear-on-select="true" :close-on-select="true"
                                    :options-limit="300" :max-height="600" :placeholder="$t('res_Label_Select')"
                                    :show-no-results="false" :hide-selected="false" :multiple="false" return-object>
                                    <template slot="noOptions">
                                        {{ $t("res_Msgs_EmptySearch") }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2 d-flex gap-2 justify-content-end">
                        <v-btn @click="getAllDocumentsForUserOrStructure" color="mx-2 primary">{{ $t("res_ButtonText_Search") }}</v-btn>
                        <v-btn @click="reset()" color=" light-blue">{{ $t("res_ButtonText_Reset") }}</v-btn>
                    </div>

                    <hr class="mt-3 mb-3">

                    <div class="d-flex flex-1 flex-column overflow-auto">
                        <v-data-table :mobile-breakpoint="0" class="custom_table_class elevation-1 move-correspondences-table" disable-sort
                            height="calc(64vh - 182px)" :headers="headers" :items-per-page="pagingData.pageSize"
                            :items="correspondencesList" :no-data-text="$t('res_Label_NoData')" caption=""
                            hide-default-footer header-fixed fixed-header show-select v-model="selectedItemsToMove"
                            item-key="transferId"
                            :class="{ 'result_available': correspondencesList.length != 0, 'searchAuditTrail': correspondencesList.length == 0 }">
                            <template v-slot:[`item.subject`]="{ item }">
                                <div>
                                    {{ item.subject }}
                                </div>
                            </template>
                            <template v-slot:[`item.referenceNumber`]="{ item }">
                                <div>
                                    {{ item.referenceNumber }}
                                </div>
                            </template>
                            <template v-slot:[`item.fromUser`]="{ item }">
                                <div>
                                    {{ item.fromUser }}
                                </div>
                            </template>
                            <template v-slot:[`item.toUser`]="{ item }">
                                <div>
                                    {{ item.toUser }}
                                </div>
                            </template>
                            <template v-slot:[`item.transferDueDate`]="{ item }">
                                <div>
                                    {{ utils.dateFormat(item.transferDueDate, 'dd/MM/yy') }}
                                </div>
                            </template>
                            <template v-slot:[`item.status`]="{ item }">
                                <div>
                                    {{ item.status }}
                                </div>
                            </template>
                            <template v-slot:[`item.purpose`]="{ item }">
                                <div>
                                    {{ item.purpose }}
                                </div>
                            </template>
                            <template v-slot:[`item.privacy`]="{ item }">
                                <div>
                                    {{ item.privacy }}
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                    <div class="mb-2">
                        <Pagination :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                            :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged" :showPageSize="true"
                            :showMargin="false">
                        </Pagination>
                    </div>
                    <hr class="mt-3 mb-3">
                    <!--class="mt-3 mb-2"-->
                    <div id="toEntityItemAndSearchBtn" class="d-flex">
                        <div class="col-6 p-0 margin-right-l">
                            <label class="mb-2 is-required">{{ $t("res_Label_ToStructureOrUser") }}</label>
                            <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                                :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="false"
                                :isMultiple="false" :selectedStructureUser="toStructureUser"
                                @structureUserSelectChanged="toEntitySelectedChange"
                                :class="{ 'border-red-validation': validation.toStructureUser, '': true }"
                                :addressBook_header="$t('res_Label_ToStructureOrUser')"
                                :hideStructureWithDisableTransfer="false" :showRemoveSingleSelectBtn="true"
                                :hideUserWithDisableTransfer="false">
                            </StructureUserSelector>
                        </div>
                        <v-btn class="primary align-self-md-end" @click="moveCorrespondences">
                            {{ $t('res_ButtonText_Move') }}
                        </v-btn>
                        <div class="align-self-md-end margin-left-sm position-relative">
                            <v-btn class="bg-gray-cts width-40px" @click="exportPopupVisible = !exportPopupVisible">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                            <div v-if="exportPopupVisible" class="popup-cts upper-popup bg-white shadow-lg"
                                v-click-outside="closeExportPopup">
                                <div class="p-3">
                                    <span class="font-weight-bold">{{ $t("res_Label_ExportAs") }}</span>
                                    <div class="d-flex pt-4 pb-2">
                                        <input type="radio" v-model="exportType" value="2">
                                        <label class="margin-left-sm">{{ $t("res_Label_Pdf") }}</label>
                                    </div>
                                    <div class="d-flex pt-2 pb-2">
                                        <input type="radio" v-model="exportType" value="1">
                                        <label class="margin-left-sm">{{ $t("res_Label_Excel") }}</label>
                                    </div>
                                    <div class="d-flex pt-2 pb-2">
                                        <input type="radio" v-model="exportType" value="0">
                                        <label class="margin-left-sm">{{ $t("res_Label_None") }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </v-card>
    </div>
</template>

<script>
import axios from 'axios';
import router from '@/router/index.js'
import constants from '@/assets/js/constants'
import * as utils from '@/assets/js/common.js'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import Pagination from '@/components/Pagination.vue';
import Multiselect from 'vue-multiselect'



export default {
    name: 'MoveCorrespondences',
    components: { StructureUserSelector, Pagination, Multiselect },
    data: function () {
        return {
            utils: utils,
            fromStructureUser: null,
            toStructureUser: null,
            selectedItemsToMove: [],
            correspondencesList: [],
            validation: {},
            showSelectedItemsValidation: false,
            exportPopupVisible: false,
            exportType: 2,
            auditTrailData: {
                oldData: [],
                newData: [],
            },
            headers: [
                { text: "", width: '0px', value: '', sortable: false },
                { text: '', value: 'data-table-select' },
                { text: this.$t("res_GridHeaders_Subject"), value: 'subject' },
                { text: this.$t("res_MenuItems_ReferenceNumber"), value: 'referenceNumber' },
                { text: this.$t("res_GridHeaders_FromUser"), value: 'fromUser' },
                { text: this.$t("res_GridHeaders_ToUser"), value: 'toUser' },
                { text: this.$t("res_GridHeaders_DueDate"), value: 'transferDueDate' },
                { text: this.$t("res_Label_Status"), value: 'status' },
                { text: this.$t("res_Label_Purpose"), value: 'purpose' },
                { text: this.$t("res_Label_Privacy"), value: 'privacy' },
            ],
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0,
            },
            filterObject: {
                subject: '',
                status: null,
                referenceNumber: ''
            },
            allStatus: [],
            transfersIds: ''
        }
    },
    mounted: function () {
        this.resetValidation();
        this.prepareStatusForSelect();
    },
    methods: {
        backToAdminPage() {
            router.push({ name: 'admin' })
        },
        fromEntitySelectedChange(structureOrUser) {
            this.fromStructureUser = structureOrUser;
        },
        toEntitySelectedChange(structureOrUser) {
            this.toStructureUser = structureOrUser;
        },
        getAllDocumentsForUserOrStructure() {
            if (!this.isValidForm(true, null))
                return;

            let userId = 0;
            let structureId = 0;
            if (this.fromStructureUser != null && this.fromStructureUser != undefined) {
                if (this.fromStructureUser.id.includes("-")) {
                    userId = this.fromStructureUser.id.split("-")[0];
                    structureId = this.fromStructureUser.id.split("-")[1];
                }
                else
                    structureId = this.fromStructureUser.id;
            }
            const statusId = utils.CheckIfNullOrEmpty(this.filterObject.status) ? 0 : this.filterObject.status.id;

            window.showLoading();
            axios.get(constants.baseApiUrl + 'Admin/GetAllCorrespondencesToMove?userId=' + userId + '&structureId=' + structureId + '&subject=' + this.filterObject.subject
                + '&referenceNumber=' + this.filterObject.referenceNumber + '&statusId=' + statusId + '&pageSize=' + this.pagingData.pageSize
                + '&pageIndex=' + this.pagingData.pageIndex)
                .then(res => {
                    if (res && res.data.length > 0) {
                        this.correspondencesList = res.data;
                        this.pagingData.totalCount = res.data[0].totalCount;
                    } else {
                        this.correspondencesList = [];
                        this.pagingData.totalCount = 0;
                    }
                    this.resetPage();
                })
                .catch(err => {
                    console.log(err);
                    window.showAlert('res_Msgs_ErrorOccured', 'error')
                })
                .finally(() => window.hideLoading())

        },
        // correspondencesItemsSelectChanged(items = '') {
        //     this.selectedItemsToMove = items;
        // },
        async moveCorrespondences() {
            if (!this.isValidForm(null, true))
                return;

            this.transfersIds = this.selectedItemsToMove.map(x => x.transferId).join(',');

            window.showLoading();
            await axios.post(constants.baseApiUrl + 'Admin/MoveCorrespondences?transfersIds=' + this.transfersIds + '&toStructureOrStructureUserId=' + (this.toStructureUser?.id ?? ''))
                .then(res => {
                    if (res && res.data && res.data.statusResult == constants.ctsActionResultsEnums.Success) {


                        this.insertAuditTrail();

                        if (this.exportType == 1 || this.exportType == 2)
                            this.exportFile(res);
                        window.showAlert("res_Msgs_MovedSuccessfully", 'success');
                    }
                    else {
                        if (res.data.errCode == constants.ctsErrCodesEnums.TransferError) {
                            for (let i = 0; i < res.data.errMsgsDictionary.length; i++) {
                                if (Number(res.data.errMsgsDictionary[i].item1) == constants.transferErrorsEnums.PrivacyLevelOfStructureReceiver)
                                    window.showAlert("res_Msgs_YouPrivacyMoveCorrespondencesRestriction", 'warning', 6000);
                                else
                                    window.showAlert(res.data.errMsgsDictionary[i].item2, 'warning');
                            }
                        }
                    }

                    this.resetPage();
                    this.getAllDocumentsForUserOrStructure();
                })
                .catch(err => {
                    console.log(err);
                    window.showAlert('res_Msgs_ErrorOccured', 'error')
                })
                .finally(() => window.hideLoading())
        },
        async insertAuditTrail() {
            // The audit-trail service/config is an optional global and is not wired in this project.
            // Guard against it being undefined so a successful move is not reported as an error.
            if (!window.auditTrailService || !window.auditTrailConfigs || !window.auditTrailConfigs.document) return;
            if (utils.CheckIfNullOrEmpty(this.fromStructureUser)) {
                const distinctitems = this.selectedItemsToMove
                    .filter((item, index, self) =>
                        index === self.findIndex(x =>
                            x.fromUserId === item.fromUserId
                        )
                    );

                distinctitems.forEach(x => {
                    this.auditTrailData.newData = {
                        transfersIds: this.transfersIds,
                        toUserStructureId: this.toStructureUser?.id ?? null,
                        fromUserStructureId: x.fromUserId + "-" + x.fromStructureId
                    };
                    window.auditTrailService.logAuditTrail(
                        window.auditTrailConfigs.document,
                        window.auditTrailConfigs.document.components.moveCorrespondences,
                        window.auditTrailConfigs.document.components.moveCorrespondences.actions.MoveCorrespondences.key,
                        [{}],
                        this.auditTrailData.newData,
                        [{ Entity: window.auditTrailConfigs.document.entities.AB27, ObjectID: parseInt(this.transfersIds) }]);

                });
            } else {
                this.auditTrailData.newData = {
                    transfersIds: this.transfersIds,
                    toUserStructureId: this.toStructureUser?.id ?? null,
                    fromUserStructureId: this.fromStructureUser?.id ?? null
                };

                window.auditTrailService.logAuditTrail(
                    window.auditTrailConfigs.document,
                    window.auditTrailConfigs.document.components.moveCorrespondences,
                    window.auditTrailConfigs.document.components.moveCorrespondences.actions.MoveCorrespondences.key,
                    [{}],
                    this.auditTrailData.newData,
                    [{ Entity: window.auditTrailConfigs.document.entities.AB27, ObjectID: parseInt(this.transfersIds) }]);
            }
        },
        resetValidation() {
            this.validation = {
                fromStructureUser: false,
                toStructureUser: false,
                selectedItemsToMove: false,
            }
        },
        isValidForm(checkFromEntity, checkToEntity) {
            let isValidForm = true;
            let isValidSelectedItems = true;
            let isValidMovement = true;

            // if (checkFromEntity) {
            //     if (utils.CheckIfNullOrEmpty(this.fromStructureUser)) {
            //         isValidForm = false;
            //         this.validation.fromStructureUser = true;
            //     } else
            //         this.validation.fromStructureUser = false;
            // }

            if (checkToEntity) {
                if (utils.CheckIfNullOrEmpty(this.toStructureUser)) {
                    isValidForm = false;
                    this.validation.toStructureUser = true;
                } else
                    this.validation.toStructureUser = false;

                if (utils.CheckIfNullOrEmpty(this.selectedItemsToMove)) {
                    isValidSelectedItems = false;
                    this.showSelectedItemsValidation = true
                    this.validation.selectedItemsToMove = true;
                } else {
                    this.showSelectedItemsValidation = false
                    this.validation.selectedItemsToMove = false;
                }

                if (!utils.CheckIfNullOrEmpty(this.fromStructureUser) && !utils.CheckIfNullOrEmpty(this.toStructureUser) && this.fromStructureUser.id == this.toStructureUser.id) {
                    isValidMovement = false;
                    this.validation.fromStructureUser = true;
                    this.validation.toStructureUser = true;
                }
                else {
                    this.validation.fromStructureUser = false;
                }
            }


            if (!isValidForm)
                window.showAlert('res_Msgs_FillRequired', 'warning');
            if (!isValidSelectedItems && this.correspondencesList.length > 0)
                window.showAlert('res_Label_PleaseSelectCorrespondencesToMove', 'warning');
            else if (!isValidSelectedItems && this.correspondencesList.length == 0)
                window.showAlert('res_Label_ThereAreNoItemsToMove', 'warning');
            if (!isValidMovement)
                window.showAlert('res_Label_YouCannotMoveItemsToSameStructureOrUser', 'warning');

            return isValidForm && isValidSelectedItems && isValidMovement;
        },
        exportFile(res) {
            axios({
                url: constants.baseApiUrl + 'Admin/ExportMoveCorrespondences?transfersIds=' + this.transfersIds + '&exportType=' + this.exportType,
                method: 'Post',
                responseType: 'blob'
            })
                .then(res => {
                    if (res) {
                        this.downloadExportedFile(res);
                    }
                })
                .catch(err => {
                    console.log(err);
                    window.showAlert('res_Msgs_ErrorOccured', 'error')
                })
        },
        downloadExportedFile(res) {
            var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
            var blob = new Blob([res.data], { type: "application/octetstream" });
            const link = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("download", "ExportedData" + `${extension}`);
            a.setAttribute("href", link);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        closeExportPopup() {
            this.exportPopupVisible = false;
        },
        resetPage() {
            this.selectedItemsToMove = [];
            this.toStructureUser = null;
            this.validation.toStructureUser = false;
            this.showSelectedItemsValidation = false;
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;
            this.getAllDocumentsForUserOrStructure();
        },
        prepareStatusForSelect() {
            axios.get(constants.baseApiUrl + 'Lookups/get-all-Statuses')
                .then(res => {
                    this.allStatus = res.data
                })
                .catch(err => console.log(err))
        },
        reset() {
            this.filterObject = {
                subject: '',
                status: null,
                referenceNumber: ''
            },
                this.fromStructureUser = null;
            this.toStructureUser = null;
            this.correspondencesList = [];
            this.pagingData = {
                pageSize: 50,
                pageIndex: 0,
                totalCount: 0
            },
                this.auditTrailData = {
                    oldData: [],
                    newData: [],
                }

        },
    },
};
</script>

<style scoped>

::v-deep .move-correspondences-table .v-data-table__wrapper table thead th {
    background: var(--table-header-color) !important;
}

::v-deep .move-correspondences-table .v-data-table__wrapper table thead th:first-child {
    border-radius: 12px 0 0 0;
}

::v-deep .move-correspondences-table .v-data-table__wrapper table thead th:last-child {
    border-radius: 0 12px 0 0;
}
</style>